<template>
    <default-button
        :icon="icon"
        :label="label"
        :type="type"
        size="xs"
        outline
        v-bind="$attrs"
        v-on="$listeners"
    />
</template>

<script>

export default {
    components: {
        DefaultButton: () => import("@/components/Common/Buttons/DefaultButton")
    },
    props: {
        icon: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        type: {
            type: String
        }
    }
}
</script>
